<template>
  <div class="h-full flex flex-col">
    <div class="p-6 pb-0">
      <div class="flex justify-between items-center mb-4">
        <h1 class="text-2xl font-bold">Config Change Requests</h1>
      </div>

      <TabView v-model:activeIndex="activeTab" @tab-change="onTabChange" class="-mx-6">
        <TabPanel header="Requests">
          <DataTable
              scrollable
              scroll-height="flex"
              :value="configChangeRequestsStore.getConfigChangeRequests"
              lazy
              paginator
              :rows="15"
              :rowsPerPageOptions="[15, 25, 50]"
              :total-records="configChangeRequestsStore.data?.total || 0"
              :loading="loading"
              @page="onPage($event)"
              @sort="onSort($event)"
              data-key="id"
              size="small"
              removable-sort
              always-show-paginator
          >
    <template #header>
      <Toolbar class="border-none shadow-none -m-3.5 rounded-none">
        <template #start>
          <div class="flex-1">
            <IconField icon-position="left">
              <InputIcon>
                <IconSearch class="text-surface-400 dark:text-surface-600 h-4 w-4"/>
              </InputIcon>
              <InputText
                  placeholder="Search config requests..."
                  class="sm:py-2"
                  v-model="searchQuery"
                  @keyup="onSearch"
              />
            </IconField>
          </div>
        </template>
      </Toolbar>
    </template>

    <Column field="id" header="ID" sortable class="pl-6 lg:pl-8 w-20 uppercase"/>

    <Column field="title" header="Title" sortable class="w-64">
      <template #body="{data}">
        <router-link :to="{ name: 'admin.config-requests.show', params: { id: data.id } }">
          <Button
              :label="data.title || '-'"
              link
              size="small"
              class="font-medium"
          />
        </router-link>
      </template>
    </Column>

    <Column field="requested_by" header="Requested By" class="w-48">
      <template #body="{data}">
        {{ data.requested_by?.name || '-' }}
      </template>
    </Column>

    <Column field="device" header="Device" class="w-48">
      <template #body="{data}">
        <router-link v-if="data.device_id" :to="{ name: 'devices.show', params: { device: data.device_id } }">
          <Button :label="data.serial_number || `Device #${data.device_id}`" link size="small"/>
        </router-link>
        <span v-else>-</span>
      </template>
    </Column>

    <Column field="created_at" header="Created At" sortable class="w-48">
      <template #body="{data}">
        {{ formatDate(data.created_at) }}
      </template>
    </Column>
            <template #empty>
              <div class="text-center py-8 text-surface-500 dark:text-surface-400">
                No pending config change requests found.
              </div>
            </template>
          </DataTable>
        </TabPanel>

        <TabPanel header="Approved">
          <DataTable
              scrollable
              scroll-height="flex"
              :value="configChangeRequestsStore.getConfigChangeRequests"
              lazy
              paginator
              :rows="15"
              :rowsPerPageOptions="[15, 25, 50]"
              :total-records="configChangeRequestsStore.data?.total || 0"
              :loading="loading"
              @page="onPage($event)"
              @sort="onSort($event)"
              data-key="id"
              size="small"
              removable-sort
              always-show-paginator
          >
            <template #header>
              <Toolbar class="border-none shadow-none -m-3.5 rounded-none">
                <template #start>
                  <div class="flex-1">
                    <IconField icon-position="left">
                      <InputIcon>
                        <IconSearch class="text-surface-400 dark:text-surface-600 h-4 w-4"/>
                      </InputIcon>
                      <InputText
                          placeholder="Search config requests..."
                          class="sm:py-2"
                          v-model="searchQuery"
                          @keyup="onSearch"
                      />
                    </IconField>
                  </div>
                </template>
              </Toolbar>
            </template>

            <Column field="id" header="ID" sortable class="pl-6 lg:pl-8 w-20 uppercase"/>
            <Column field="title" header="Title" sortable class="w-64">
              <template #body="{data}">
                <router-link :to="{ name: 'admin.config-requests.show', params: { id: data.id } }">
                  <Button :label="data.title || '-'" link size="small" class="font-medium"/>
                </router-link>
              </template>
            </Column>
            <Column field="requested_by" header="Requested By" class="w-48">
              <template #body="{data}">{{ data.requested_by?.name || '-' }}</template>
            </Column>
            <Column field="device" header="Device" class="w-48">
              <template #body="{data}">
                <router-link v-if="data.device_id" :to="{ name: 'devices.show', params: { device: data.device_id } }">
                  <Button :label="data.serial_number || `Device #${data.device_id}`" link size="small"/>
                </router-link>
                <span v-else>-</span>
              </template>
            </Column>
            <Column field="created_at" header="Created At" sortable class="w-48">
              <template #body="{data}">{{ formatDate(data.created_at) }}</template>
            </Column>
            <template #empty>
              <div class="text-center py-8 text-surface-500 dark:text-surface-400">
                No approved config change requests found.
              </div>
            </template>
          </DataTable>
        </TabPanel>

        <TabPanel header="Rejected">
          <DataTable
              scrollable
              scroll-height="flex"
              :value="configChangeRequestsStore.getConfigChangeRequests"
              lazy
              paginator
              :rows="15"
              :rowsPerPageOptions="[15, 25, 50]"
              :total-records="configChangeRequestsStore.data?.total || 0"
              :loading="loading"
              @page="onPage($event)"
              @sort="onSort($event)"
              data-key="id"
              size="small"
              removable-sort
              always-show-paginator
          >
            <template #header>
              <Toolbar class="border-none shadow-none -m-3.5 rounded-none">
                <template #start>
                  <div class="flex-1">
                    <IconField icon-position="left">
                      <InputIcon>
                        <IconSearch class="text-surface-400 dark:text-surface-600 h-4 w-4"/>
                      </InputIcon>
                      <InputText
                          placeholder="Search config requests..."
                          class="sm:py-2"
                          v-model="searchQuery"
                          @keyup="onSearch"
                      />
                    </IconField>
                  </div>
                </template>
              </Toolbar>
            </template>

            <Column field="id" header="ID" sortable class="pl-6 lg:pl-8 w-20 uppercase"/>
            <Column field="title" header="Title" sortable class="w-64">
              <template #body="{data}">
                <router-link :to="{ name: 'admin.config-requests.show', params: { id: data.id } }">
                  <Button :label="data.title || '-'" link size="small" class="font-medium"/>
                </router-link>
              </template>
            </Column>
            <Column field="requested_by" header="Requested By" class="w-48">
              <template #body="{data}">{{ data.requested_by?.name || '-' }}</template>
            </Column>
            <Column field="rejected_by" header="Rejected By" class="w-48">
              <template #body="{data}">{{ data.reviewed_by?.name || '-' }}</template>
            </Column>
            <Column field="device" header="Device" class="w-48">
              <template #body="{data}">
                <router-link v-if="data.device_id" :to="{ name: 'devices.show', params: { device: data.device_id } }">
                  <Button :label="data.serial_number || `Device #${data.device_id}`" link size="small"/>
                </router-link>
                <span v-else>-</span>
              </template>
            </Column>
            <Column field="rejected_reason" header="Rejection Reason" class="w-64">
              <template #body="{data}">{{ data.rejected_reason || '-' }}</template>
            </Column>
            <Column field="created_at" header="Created At" sortable class="w-48">
              <template #body="{data}">{{ formatDate(data.created_at) }}</template>
            </Column>
            <template #empty>
              <div class="text-center py-8 text-surface-500 dark:text-surface-400">
                No rejected config change requests found.
              </div>
            </template>
          </DataTable>
        </TabPanel>

        <TabPanel header="Applied">
          <DataTable
              scrollable
              scroll-height="flex"
              :value="configChangeRequestsStore.getConfigChangeRequests"
              lazy
              paginator
              :rows="15"
              :rowsPerPageOptions="[15, 25, 50]"
              :total-records="configChangeRequestsStore.data?.total || 0"
              :loading="loading"
              @page="onPage($event)"
              @sort="onSort($event)"
              data-key="id"
              size="small"
              removable-sort
              always-show-paginator
          >
            <template #header>
              <Toolbar class="border-none shadow-none -m-3.5 rounded-none">
                <template #start>
                  <div class="flex-1">
                    <IconField icon-position="left">
                      <InputIcon>
                        <IconSearch class="text-surface-400 dark:text-surface-600 h-4 w-4"/>
                      </InputIcon>
                      <InputText
                          placeholder="Search config requests..."
                          class="sm:py-2"
                          v-model="searchQuery"
                          @keyup="onSearch"
                      />
                    </IconField>
                  </div>
                </template>
              </Toolbar>
            </template>

            <Column field="id" header="ID" sortable class="pl-6 lg:pl-8 w-20 uppercase"/>
            <Column field="title" header="Title" sortable class="w-64">
              <template #body="{data}">
                <router-link :to="{ name: 'admin.config-requests.show', params: { id: data.id } }">
                  <Button :label="data.title || '-'" link size="small" class="font-medium"/>
                </router-link>
              </template>
            </Column>
            <Column field="requested_by" header="Requested By" class="w-48">
              <template #body="{data}">{{ data.requested_by?.name || '-' }}</template>
            </Column>
            <Column field="device" header="Device" class="w-48">
              <template #body="{data}">
                <router-link v-if="data.device_id" :to="{ name: 'devices.show', params: { device: data.device_id } }">
                  <Button :label="data.serial_number || `Device #${data.device_id}`" link size="small"/>
                </router-link>
                <span v-else>-</span>
              </template>
            </Column>
            <Column field="created_at" header="Created At" sortable class="w-48">
              <template #body="{data}">{{ formatDate(data.created_at) }}</template>
            </Column>
            <template #empty>
              <div class="text-center py-8 text-surface-500 dark:text-surface-400">
                No applied config change requests found.
              </div>
            </template>
          </DataTable>
        </TabPanel>
      </TabView>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useConfigChangeRequestsStore } from "@/stores/configChangeRequests.js";
import { IconClipboardCheck, IconSearch } from "@tabler/icons-vue";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";
import dayjs from 'dayjs';

export default {
  name: 'ConfigRequestsIndex',
  components: {
    IconClipboardCheck,
    IconSearch,
    IconField,
    InputIcon,
  },
  data() {
    return {
      loading: false,
      searchQuery: '',
      activeTab: 0,
      params: {
        page: 1,
        per_page: 15,
        sort: 'created_at',
        order: 'desc',
        filter: {
          search: '',
          status: 1, // Default to Pending
        }
      }
    }
  },
  computed: {
    ...mapStores(useConfigChangeRequestsStore),
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        await this.configChangeRequestsStore.indexConfigChangeRequests(this.params);
      } finally {
        this.loading = false;
      }
    },
    onPage(event) {
      this.params.page = event.page + 1;
      this.params.per_page = event.rows;
      this.loadData();
    },
    onSort(event) {
      this.params.sort = event.sortField || 'created_at';
      this.params.order = event.sortOrder === 1 ? 'asc' : 'desc';
      this.loadData();
    },
    onSearch() {
      this.params.filter.search = this.searchQuery;
      this.params.page = 1;
      this.loadData();
    },
    formatDate(date) {
      return date ? dayjs(date).format('DD/MM/YYYY HH:mm') : '-';
    },
    getStatusLabel(status) {
      const labels = {
        1: 'Requested',
        2: 'Approved',
        3: 'Rejected',
        4: 'Applied'
      };
      return labels[status] || 'Unknown';
    },
    getStatusSeverity(status) {
      const severities = {
        1: 'info',      // Requested - blue
        2: 'success',   // Approved - green
        3: 'danger',    // Rejected - red
        4: 'secondary'  // Applied - gray
      };
      return severities[status] || 'secondary';
    },
    onTabChange(event) {
      // Map tab index to status: 0=Requests(1), 1=Approved(2), 2=Rejected(3), 3=Applied(4)
      const statusMap = {
        0: 1, // Requests
        1: 2, // Approved
        2: 3, // Rejected
        3: 4  // Applied
      };
      this.params.filter.status = statusMap[event.index];
      this.params.page = 1;
      this.loadData();
    }
  },
  async mounted() {
    await this.loadData();
  }
}
</script>

<style scoped>
:deep(.p-datatable-loading-icon) {
  z-index: 10;
}
:deep(.p-datatable-wrapper) {
  min-height: 200px;
}
</style>
